// src/pages/TestQuestionCreate.jsx
import React, { useEffect, useState } from "react";
import axios                 from "axios";
import { useNavigate, useParams } from "react-router-dom";
import useUserLanguage       from "../../hooks/useUserLanguage";
import useTranslations       from "../../hooks/useTranslations";
import { SingleImageDropzone } from "../DropzoneComponents";
import MultiSelectTags from "../shared/MultiSelectTags";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* ---------- Sabit şablonlar ---------- */
const EMPTY_OPTION = { text: "", file: null, preview: null, score: "" };
const EMPTY_ROW = { text: "", file: null, preview: null, score: "" };
const EMPTY_QUESTION = {
  id      : null,
  text    : "",
  description: "",
  file    : null,   // yeni seçilecek dosya
  preview : null,   // var olan (URL) ya da file için objectURL
  type    : "single",
  category_ids: [],
  question_type_id: "",
  options : [{ ...EMPTY_OPTION }],
  rows: [ { ...EMPTY_ROW } ],
  dual_result_id: null, 
};

export default function TestQuestionCreate() {
  const { id: testId } = useParams();
  const [questions, setQuestions] = useState([{ ...EMPTY_QUESTION }]);
  const [loading,   setLoading]   = useState(false);
  const [categories, setCategories] = useState([]);
  const [testInfo, setTestInfo] = useState(null);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [dualTitles, setDualTitles] = useState([]); 


  /* i18n */
  const lang             = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;
  const nav = useNavigate();

  /* ────────────────────────────────────────
     1) COMPONENT MOUNT → mevcut soruları çek
     ──────────────────────────────────────── */
useEffect(() => {
  (async () => {
    if (!testInfo?.has_dual_main_result) return;
    try {
      const token = localStorage.getItem("admin_token");
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const { data } = await axios.get(
        `${baseUrl}/api/dual-results/tests/${testId}/titles`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDualTitles(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("❌ Dual titles fetch error:", err);
    }
  })();
}, [testInfo?.has_dual_main_result, testId]);

     useEffect(() => {
  (async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/question-types`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setQuestionTypes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("❌ Şablonlar alınamadı:", err);
    }
  })();
}, []);

  useEffect(() => {
  console.log("🔍 testInfo:", testInfo);
}, [testInfo]);

useEffect(() => {
  (async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const baseUrl = process.env.REACT_APP_API_BASE_URL;

      // 1) Test bilgisi
      const testRes = await axios.get(`${baseUrl}/api/tests/${testId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTestInfo(testRes.data);

      // 2) Kategoriler (sadece seçim listesi için)
      const catRes = await axios.get(
        `${baseUrl}/api/test-categories/${testId}/categories`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const incoming = catRes.data;
      const catArray = Array.isArray(incoming)
        ? incoming
        : Array.isArray(incoming.data)
          ? incoming.data
          : [];
      setCategories(catArray);

      // 3) Soruları al **tam** olarak atıyoruz:
      const qRes = await axios.get(
        `${baseUrl}/api/tests/${testId}/questions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const qs = Array.isArray(qRes.data) ? qRes.data : [];
      setQuestions(
        qs.map((q) => ({
          id: q.id,
          text: q.text,
          description: q.description || "", 
          type: q.type ?? "single",
          question_type_id: q.question_type_id,
          dual_result_id: q.dualResult?.id ?? null,
          file: null,
          preview: q.image_url
            ? `${baseUrl}${q.image_url}`
            : q.imageUrl?.startsWith("http")
            ? q.imageUrl
            : null,

          // işte burası: TestCategories dizisinden id’leri alıyoruz
          category_ids: Array.isArray(q.TestCategories)
            ? q.TestCategories.map((c) => c.id)
            : [],

          options: (q.options || []).map((o) => ({
            text: o.text,
            score: String(o.score ?? ""),
            file: null,
            preview: o.image_url
              ? `${baseUrl}${o.image_url}`
              : o.imageUrl?.startsWith("http")
              ? o.imageUrl
              : null,
          })),

          // eğer rows ihtiyacınız yoksa silebilirsiniz
          rows: Array.isArray(q.rows) ? q.rows : [],
        }))
      );
    } catch (err) {
      console.error("❌ Veri yüklenirken hata:", err);
    }
  })();
}, [testId]);

  /* ──────────────────────────────
     2) YARDIMCI STATE GÜNCELLEYİCİLER
     ────────────────────────────── */
  const updateQuestion = (qIdx, patch) =>
    setQuestions((qs) =>
      qs.map((q, i) => (i === qIdx ? { ...q, ...patch } : q))
    );

  const updateOption = (qIdx, oIdx, patch) =>
    setQuestions((qs) =>
      qs.map((q, qi) =>
        qi === qIdx
          ? {
              ...q,
              options: q.options.map((o, oi) =>
                oi === oIdx ? { ...o, ...patch } : o
              ),
            }
          : q
      )
    );

  /* ──────────────────────────────
     3) FORM GÖNDER
     ────────────────────────────── */
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // 1) Gönderilecek meta’yı hazırla
    const meta = questions.map((q, qi) => ({
      // soru ortak alanları
      id               : q.id,
      text             : q.text,
      description      : q.description || null,
      type             : q.type,
      category_ids     : q.category_ids,
      question_type_id : q.question_type_id,
      dual_result_id: q.dual_result_id || null,

      // sadece şıklara score ekliyoruz
      options : q.options.map((o, oi) => ({
        text       : o.text,
        score      : o.score,                            // sadece şık-level score
        imageField : o.file ? `option_${qi}_${oi}` : null,
        keepImage  : !o.file && !!o.preview,
      })),

      // tablo şablonundaki satırlarınız varsa
      rows: (q.rows || []).map((r, ri) => ({
        text       : r.text,
        imageField : r.file ? `row_${qi}_${ri}` : null,
        keepImage  : !r.file && !!r.preview,
      })),

      // soru görseli için
      imageField : q.file ? `question_${qi}` : null,
      keepImage  : !q.file && !!q.preview,
    }));

    // 2) FormData oluştur
    const fd = new FormData();
    fd.append("questions", JSON.stringify(meta));

    // 3) Dosyaları ekle
    questions.forEach((q, qi) => {
      if (q.file) {
        fd.append(`question_${qi}`, q.file);
      }
      q.options.forEach((o, oi) => {
        if (o.file) {
          fd.append(`option_${qi}_${oi}`, o.file);
        }
      });
      (q.rows || []).forEach((r, ri) => {
        if (r.file) {
          fd.append(`row_${qi}_${ri}`, r.file);
        }
      });
    });

    // 4) API çağrısı
    const token = localStorage.getItem("admin_token");
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/tests/${testId}/add-questions`,
      fd,
      { headers: { Authorization: `Bearer ${token}` } }
    );

                  toast.success("Sorular kaydedildi!");
                  setTimeout(() => {
                    nav(`/test/table`);
                  }, 1000);
  } catch (err) {
    console.error("❌ add-questions hatası:", err);
    toast.error(t("SAVE_ERROR", "Kaydedilirken hata oluştu"));
  } finally {
    setLoading(false);
  }
};


const isMultiple = !!testInfo?.multiple_category;
const hasCategory = !!testInfo?.has_category;
  /* ──────────────────────────────
     4) RENDER
     ────────────────────────────── */
return (
<div className="container mt-4">
   <ToastContainer />
   <div className="d-flex align-items-center justify-content-between mb-3">
  <div className="small text-muted">
    Test: <strong>{testInfo?.name || `#${testId}`}</strong>
  </div>
</div>

  <form className="card p-4" onSubmit={handleSubmit}>
    <h5 className="fw-bold mb-4">{t("ADD_QUESTIONS", "Soruları Ekle")}</h5>

    {questions.map((q, qi) => (
      <div key={qi} className="border border-2 border-primary rounded p-4 mb-4">

        {/* Başlık + Sil */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="fw-bold fs-6">
            {t("QUESTION", "Soru")} #{qi + 1}
          </span>
          {questions.length > 1 && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() =>
                setQuestions(qs => qs.filter((_, i) => i !== qi))
              }
            >
              {t("DELETE", "Sil")}
            </button>
          )}
        </div>

        {/* Soru Metni */}
        <div className="mb-3">
          <label className="form-label fw-semibold">
            {t("QUESTION_TEXT", "Soru Metni")}
          </label>
          <input
            className="form-control"
            value={q.text}
            onChange={e => updateQuestion(qi, { text: e.target.value })}
          />
        </div>
        <div className="mb-3">
  <label className="form-label fw-semibold">
    {t("QUESTION_DESCRIPTION", "Soru Açıklaması (isteğe bağlı)")}
  </label>
  <textarea
    className="form-control"
    rows={3}
    value={q.description}
    onChange={(e) => updateQuestion(qi, { description: e.target.value })}
    placeholder={t("QUESTION_DESCRIPTION_PH", "Bu soruya dair açıklama / ipucu...")}
  />
</div>

        {/* Soru Görseli */}
        <div className="mb-3">
          <label className="form-label fw-semibold">
            {t("QUESTION_IMAGE", "Soru Görseli")}
          </label>
<SingleImageDropzone
  fieldName={`question_${qi}`}
  fieldValue={q.preview || q.file}
  // Kırpma sonrası burada hem file hem preview state’e geçiyor:
  setFieldValues={(file, preview) =>
    updateQuestion(qi, { file, preview })
  }
  // İlk seçimde de preview'u oluşturuyoruz:
  onChange={(file) =>
    updateQuestion(qi, {
      file,
      preview: URL.createObjectURL(file),
    })
  }
  onRemove={() => updateQuestion(qi, { file: null, preview: null })}
  maxWidth={800}
  maxHeight={600}
  required={false}
/>
        </div>

        {/* Soru Tipi */}
        <div className="mb-4">
          <label className="form-label fw-semibold">
            {t("QUESTION_TYPE", "Soru Tipi")}
          </label>
          <select
            className="form-select"
            value={q.type}
            onChange={e => updateQuestion(qi, { type: e.target.value })}
          >
            <option value="single">{t("SINGLE", "Tekli Seçim")}</option>
            <option value="multi">{t("MULTI", "Çoklu Seçim")}</option>
          </select>
        </div>

        {/* Kategori */}
        {hasCategory && (
          <div className="mb-3">
            <label className="form-label fw-semibold">
              {t("QUESTION_CATEGORY", "Soru Kategorisi")}
            </label>
            {isMultiple ? (
              <MultiSelectTags
                options={categories.map(cat => ({
                  value: cat.id,
                  label: cat.name,
                }))}
                value={categories
                  .filter(cat => q.category_ids.includes(cat.id))
                  .map(cat => ({ value: cat.id, label: cat.name }))}
                onChange={sel =>
                  updateQuestion(qi, {
                    category_ids: sel.map(o => o.value),
                  })
                }
              />
            ) : (
              <select
                className="form-select"
                value={q.category_ids[0] || ""}
                onChange={e =>
                  updateQuestion(qi, {
                    category_ids: e.target.value ? [Number(e.target.value)] : [],
                  })
                }
              >
                <option value="">{t("SELECT_CATEGORY", "Kategori seçin...")}</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}
        {/* Sonuç Başlığı (sadece ikili ana sonuç aktifse) */}
{Boolean(testInfo?.has_dual_main_result) && (
  <div className="mb-3">
    <label className="form-label fw-semibold">Sonuç Başlığı</label>
    <select
      className="form-select"
      value={q.dual_result_id || ""}   // q => map içindeki soru
      onChange={(e) =>
        updateQuestion(qi, {
          dual_result_id: e.target.value ? Number(e.target.value) : null,
        })
      }
    >
      <option value="">Başlık seçin…</option>
      {dualTitles.map((dr) => (
        <option key={dr.id} value={dr.id}>
          {dr.title}
        </option>
      ))}
    </select>
  </div>
)}


        {/* Şablon Tipi */}
        <div className="mb-3">
          <label className="form-label fw-semibold">
            {t("QUESTION_TEMPLATE", "Şablon Tipi")}
          </label>
          <select
            className="form-select"
            value={q.question_type_id || ""}
            onChange={e => updateQuestion(qi, { question_type_id: Number(e.target.value) })}
            required
          >
            <option value="">{t("SELECT_TEMPLATE", "Şablon seçin...")}</option>
            {questionTypes.map(qt => (
              <option key={qt.id} value={qt.id}>
                {qt.title}
              </option>
            ))}
          </select>
        </div>

        {/* ── ŞIKLAR ── */}
{/* ───────── ŞIKLAR ───────── */}
<div className="mb-3">
  <h6>{t("OPTIONS", "Şıklar")}</h6>
  {q.options.map((o, oi) => (
    <div key={oi} className="border rounded p-3 mb-3">
      
      {/* Şık Metni */}
      <div className="mb-2">
        <label className="form-label fw-semibold">
          {t("OPTION_TEXT", "Şık Metni")}
        </label>
        <input
          className="form-control"
          value={o.text}
          onChange={(e) => updateOption(qi, oi, { text: e.target.value })}
        />
      </div>

      {/* Şık Görseli */}
      <div className="mb-2">
        <label className="form-label fw-semibold">
          {t("OPTION_IMAGE", "Şık Görseli")}
        </label>
<SingleImageDropzone
  fieldName={`option_${qi}_${oi}`}
  fieldValue={o.preview || o.file}
  setFieldValues={() => {}} // <-- Eksik olan bu prop boş fonksiyon olarak eklenmeli
  onChange={(file) =>
    updateOption(qi, oi, {
      file,
      preview: URL.createObjectURL(file),
    })
  }
  onRemove={() =>
    updateOption(qi, oi, { file: null, preview: null })
  }
  maxWidth={400}
  maxHeight={300}
  required={false}
/>

      </div>

      {/* Şık Puanı */}
      <div className="mb-2">
        <label className="form-label fw-semibold">
          {t("OPTION_SCORE", "Şık Puanı")}
        </label>
        <input
          type="number"
          className="form-control"
          value={o.score}
          onChange={(e) =>
            updateOption(qi, oi, { score: e.target.value })
          }
        />
      </div>

      <button
        type="button"
        className="btn btn-sm btn-outline-danger"
        onClick={() =>
          updateQuestion(qi, {
            options: q.options.filter((_, idx) => idx !== oi),
          })
        }
      >
        {t("DELETE_OPTION", "Şık Sil")}
      </button>
    </div>
  ))}
  
  <button
    type="button"
    className="btn btn-sm btn-outline-secondary"
    onClick={() =>
      updateQuestion(qi, {
        options: [...q.options, { ...EMPTY_OPTION }],
      })
    }
  >
    {t("ADD_OPTION", "Şık Ekle")}
  </button>
</div>


        {/* Eğer şablon 4 veya 5 ise alt soru ekle butonu */}
        {[4,5].includes(q.question_type_id) && (
          <button
            type="button"
            className="btn btn-sm btn-success mt-3"
            onClick={() => {
              const newSubQuestion = {
                ...EMPTY_QUESTION,
                options: q.options.map(opt => ({ ...opt })),
              };
              setQuestions(qs => [
                ...qs.slice(0, qi + 1),
                newSubQuestion,
                ...qs.slice(qi + 1),
              ]);
            }}
          >
            Alt Soru Ekle (Şıklar Kopyalanır)
          </button>
        )}
      </div>
    ))}

    {/* Standart Yeni Soru Ekle butonu */}
    <div className="text-center mb-4">
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={() => setQuestions(qs => [...qs, { ...EMPTY_QUESTION }])}
      >
        {t("ADD_NEW_QUESTION", "Yeni Soru Ekle")}
      </button>
    </div>

    {/* Kaydet */}
    <div className="text-center">
      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? t("LOADING", "Yükleniyor…") : t("SAVE_ALL", "Kaydet")}
      </button>
    </div>
  </form>
</div>
);

}
